export default "__VITE_ASSET__r23xMk0O__"